import React from "react";
import { AnchorIcon } from "./heading-anchor.styled";
import * as FA from "../../styles/fontawesome";

interface IHeadingAnchorProps {
  tag: string;
}
const HeadingAnchor = (props: IHeadingAnchorProps) => {
  return (
    <AnchorIcon className="heading-anchor" href={`#${props.tag}`}>
      <i css={FA.LinkLight} />
    </AnchorIcon>
  );
};

export default HeadingAnchor;
